export default __webpack_public_path__ + "static/media/ibank-logo-white.44517cf8.png";